// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"91bacd3c","349":"88dfe397","647":"13e849fd","712":"de88cb20","787":"db72d54a","976":"b540bebd"}[chunkId] + ".chunk.js";
};